import { apiFetch } from './interceptor';
const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/v1';

export const userApi = {
  // get: get user
  getUser: async (token) => {
    const response = await apiFetch(`${BASE_URL}/user`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.json();
  },
  
  // patch: update user
  updateUser: async (userId, token, user) => {
    const response = await apiFetch(`${BASE_URL}/users/${userId}`, {
      method: 'PATCH',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(user)
    });
    
    const data = await response.json();
    return { status: response.status, data };
  },

  // get: get all users
  getUsers: async (token, page=1, limit=20, roleId="", search="") => {
    let url = `${BASE_URL}/users?page=${page}&limit=${limit}`;
    
    // Add roleId if provided
    if (roleId) {
      url += `&roleId=${roleId}`;
    }
    
    // Add search if provided
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    
    const response = await apiFetch(url, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    const data = await response.json();
    return { status: response.status, data };
  },

  // get: get user by id
  getUserById: async (token, userId) => {
    const response = await apiFetch(`${BASE_URL}/users/${userId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    const data = await response.json();
    return { status: response.status, data };
  },

  //get: get user by roleId
  getUserByRoleId: async (token, roleId) => {
    const response = await apiFetch(`${BASE_URL}/users/users-by-role/${roleId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    const data = await response.json();
    return { status: response.status, data };
  },
  
  updateUserGame: async (token, userId, gameId, active) => {
    const response = await apiFetch(`${BASE_URL}/userGames`, {
      method: 'PATCH',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ userId, gameId, active })
    });
    const data = await response.json();
    return { status: response.status, data };
  },

  getUserHeirarchy: async (token, userId) => {
    const response = await apiFetch(`${BASE_URL}/users/heirarchy/${userId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    const data = await response.json();
    return { status: response.status, data };
  },

  updateUpline: async (token, userId, uplineId) => {
    const response = await apiFetch(`${BASE_URL}/users/update-upline/${userId}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ uplineId })
    });
    const data = await response.json();
    return { status: response.status, data };
  }
}

